export default __webpack_public_path__ + "static/media/awards-bg.c9d6c915.png";